import PropTypes from "prop-types";

/**
 * Visual representation of a LaGigaFam resistance band with numbered zones.
 * Renders a single-color band or a multi-color trio band.
 */
export default function BandVisual({ color, tri = null, label = "" }) {
  const numbers = [1, 2, 3, 4, 5, 6];

  if (tri) {
    // Trio band with 3 colored zones
    return (
      <div className="w-full h-24 rounded-2xl overflow-hidden shadow-md border-4 border-white flex items-stretch relative">
        {tri.map((zone, i) => (
          <div
            key={i}
            className="flex-1 flex items-center justify-center relative"
            style={{ backgroundColor: zone.color }}
          >
            <span className="font-display font-black text-white text-lg drop-shadow">
              {zone.label}
            </span>
          </div>
        ))}
        {label && (
          <div className="absolute inset-x-0 -bottom-1 flex items-center justify-center">
            <span className="bg-white/95 text-neutral-900 text-[10px] font-black uppercase tracking-widest px-2 py-0.5 rounded-full">
              {label}
            </span>
          </div>
        )}
      </div>
    );
  }

  return (
    <div
      className="w-full h-24 rounded-2xl overflow-hidden shadow-md border-4 border-white flex items-center justify-between px-2 relative"
      style={{ backgroundColor: color }}
    >
      {numbers.slice(0, 3).map((n) => (
        <span
          key={n}
          className="font-display text-white font-black text-2xl w-8 text-center drop-shadow"
        >
          {n}
        </span>
      ))}
      <span className="font-display italic text-white/95 font-black text-sm tracking-tight px-1 whitespace-nowrap">
        LaGiga<span className="text-black/70">FAM</span>
      </span>
      {numbers.slice(3, 6).map((n) => (
        <span
          key={n}
          className="font-display text-white font-black text-2xl w-8 text-center drop-shadow"
        >
          {n}
        </span>
      ))}
      {label && (
        <div className="absolute -bottom-2 left-1/2 -translate-x-1/2">
          <span className="bg-neutral-900 text-white text-[10px] font-black uppercase tracking-widest px-2 py-0.5 rounded-full">
            {label}
          </span>
        </div>
      )}
    </div>
  );
}

BandVisual.propTypes = {
  color: PropTypes.string,
  tri: PropTypes.array,
  label: PropTypes.string,
};
